import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon, CheckCircle2Icon } from 'lucide-react';
const comparisons = [{
  pain: 'Fascia inflamada, talón destruido',
  solution: 'Arco plantar activado y blindado'
}, {
  pain: 'Plantillas de gel como muleta',
  solution: 'Pie que se sostiene solo'
}, {
  pain: 'Dolor al primer paso del día',
  solution: 'Primer paso sin pensar en el talón'
}, {
  pain: 'Kinesio cada semana, sin solución',
  solution: '15 min/día, desde el living'
}, {
  pain: '"Lo mío es crónico"',
  solution: 'Fase 3: Blindaje permanente'
}];
export function MockupSection() {
  return <section className="py-6 md:py-10 px-4 bg-dark-card" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl md:text-2xl font-black uppercase text-white text-center mb-4" data-id="element-106">
          El Cambio que Tu Pie Necesita
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-xl border border-dark-border overflow-hidden" data-id="element-107">
          <div className="grid grid-cols-2" data-id="element-108">
            <div className="bg-red-500/10 px-3 py-3 text-center border-b border-r border-dark-border" data-id="element-109">
              <span className="text-pain font-black text-base md:text-lg uppercase" data-id="element-110">
                ❌ Estado Dolor
              </span>
            </div>
            <div className="bg-neon/5 px-3 py-3 text-center border-b border-dark-border" data-id="element-111">
              <span className="text-neon font-black text-base md:text-lg uppercase" data-id="element-112">
                ✅ Resultado
              </span>
            </div>
          </div>

          {comparisons.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisons.length - 1 ? 'border-b border-dark-border' : ''}`} data-id="element-113">
              <div className="px-3 py-3 flex items-start gap-2 border-r border-dark-border" data-id="element-114">
                <XCircleIcon className="w-4 h-4 text-pain shrink-0 mt-0.5" data-id="element-115" />
                <span className="text-base md:text-lg text-white" data-id="element-116">
                  {row.pain}
                </span>
              </div>
              <div className="px-3 py-3 flex items-start gap-2" data-id="element-117">
                <CheckCircle2Icon className="w-4 h-4 text-neon shrink-0 mt-0.5" data-id="element-118" />
                <span className="text-base md:text-lg text-white font-medium" data-id="element-119">
                  {row.solution}
                </span>
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 flex flex-col items-center gap-6" data-id="element-120">
          <a href="#pricing" className="inline-flex items-center justify-center w-full max-w-md py-4 bg-neon text-black font-heading font-black rounded-xl text-base md:text-lg uppercase tracking-wide hover:bg-neon-hover transition-colors shadow-[0_0_25px_rgba(212,244,22,0.2)]" data-id="element-121">
            SI QUIERO EL EBOOK
          </a>
          <img src="https://cdn.magicpatterns.com/uploads/9YKC6ywXjrxyhGCD9bhzwo/download.webp" alt="Dolor al jugar, clavo en el talón, miedo a lesionarte" className="w-full max-w-md rounded-xl" loading="lazy" decoding="async" data-id="element-122" />
        </motion.div>
      </div>
    </section>;
}